import { createSelector } from 'reselect';

import getTable from './getTable';
import { getDisableTableNumberSaleBody } from './config';

export interface ITableOrderSaleBodyContentHttpDto {
  PrinterSettings: {
    HidePickupTime: boolean;
  };
  TableNumber?: string;
}

export default createSelector(
  [getTable, getDisableTableNumberSaleBody],
  (table, disableTableNumberSaleBody): ITableOrderSaleBodyContentHttpDto => ({
    ...(disableTableNumberSaleBody === false
      ? { TableNumber: String(table) }
      : {}),
    PrinterSettings: {
      HidePickupTime: true,
    },
  }),
);
